<template>
  <footer style="background-color: #505050;" class="text-center text-muted py-5 mt-auto">
    <div class="container">
      <small class="text-light">&copy; 2025 Oportunidades RH Sustenidos. Todos os direitos reservados. Desenvolvido por <a style="color:white" href="https://inovahouse.com.br">Inova House</a></small>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterVie",
};
</script>
